import React from 'react';
import NotificationSystem from 'rc-notification';
import { BasicNotification } from '../shared/components/Notification';

class Notifications {

    static notification = null;

    constructor() {
        if (!this.notification) {
            NotificationSystem.newInstance({}, (n) => {
                this.notification = n
            });
        }
    }

    static Colors = {
        SUCCESS: 'success',
        ERROR: 'danger',
        WARNING: 'warning'
    }

    static showNotification = (title, message, color) => {

        const createNotification = (title, message, color) => {
            this.notification.notice({
                content: <BasicNotification
                    title={title}
                    message={message}
                    color={color}
                />,
                duration: 5,
                closable: true,
                style: { top: 0, left: 'calc(100vw - 100%)' },
                className: 'right-up'
            });
        }

        if (!this.notification) {
            NotificationSystem.newInstance({}, (n) => {
                this.notification = n
                createNotification(title, message, color);
            });
        } else {
            createNotification(title, message, color);
        }
    };

}

export default Notifications;
